import request from '@/utils/request'

// 查询轨道交通线路列表
export function listLine(query) {
  return request({
    url: '/admin/metro/line/list',
    method: 'get',
    params: query
  })
}

// 查询轨道交通线路详细
export function getLine(lineId) {
  return request({
    url: '/admin/metro/line/getInfo?lineId=' + lineId,
    method: 'get'
  })
}

// 新增轨道交通线路
export function addLine(data) {
  return request({
    url: '/admin/metro/line',
    method: 'post',
    data: data
  })
}

// 修改轨道交通线路
export function updateLine(data) {
  return request({
    url: '/admin/metro/line',
    method: 'put',
    data: data
  })
}

// 修改轨道交通线路状态
export function updateStatus(lineId,lineStatus) {
  const data = {
    lineId,
    lineStatus
  }
  return request({
    url: '/admin/metro/line/updateStatus',
    method: 'put',
    data: data
  })
}

// 删除轨道交通线路
export function delLine(lineId) {
  return request({
    url: '/admin/metro/line/deleteLine?lineId='+lineId,
    method: 'delete'
  })
}

// 查询轨道交通线路列表
export function lineSelect(metroCode) {
  return request({
    url: '/admin/metro/line/optionSelect?metroCode='+metroCode,
    method: 'get'
  })
}
